module.exports = __webpack_public_path__ + "static/media/icons-solid-check-orange.a08939f1.svg";